import classNames from "classnames";
import * as React from "react";
import * as styles from "source/app/presentation/Shared/ActivePanel/ActivePanel.css";
import { IRenderPanelProps } from "source/app/presentation/Shared/ActivePanel/Render/Helpers/IRenderPanelProps";
import { EPanelId } from "source/app/services/Shared/EPanelId";

export class RenderPanel extends React.Component<IRenderPanelProps, {}> {
    shouldComponentUpdate(nextProps: IRenderPanelProps) {
        const panelId = nextProps.navigationMenuItem.id;
        const hasNeverBeenMounted = !mountedPanelIds.includes(panelId);
        const isVisibleNow =
            this.props.isActive ||
            this.props.transitionSourcePanelId === panelId;
        const isVisibleNext =
            nextProps.isActive || nextProps.transitionSourcePanelId === panelId;
        const unmountWhenInactive =
            this.props.navigationMenuItem.unmountWhenInactive === true ||
            nextProps.navigationMenuItem.unmountWhenInactive === true;

        if (unmountWhenInactive) {
            return (
                isVisibleNow !== isVisibleNext ||
                nextProps.isActive !== this.props.isActive ||
                nextProps.transitionSourcePanelId !==
                    this.props.transitionSourcePanelId ||
                nextProps.isPanelTransitionReady !==
                    this.props.isPanelTransitionReady
            );
        }

        if (hasNeverBeenMounted) {
            return true;
        }

        if (isVisibleNow || isVisibleNext) {
            return (
                nextProps.isActive !== this.props.isActive ||
                nextProps.transitionSourcePanelId !==
                    this.props.transitionSourcePanelId ||
                nextProps.isPanelTransitionReady !==
                    this.props.isPanelTransitionReady
            );
        }

        return false;
    }

    render() {
        const panelId = this.props.navigationMenuItem.id;
        const hasNeverBeenMounted = !mountedPanelIds.includes(panelId);
        const isTransitionSource =
            this.props.transitionSourcePanelId === panelId;
        const isPanelVisible = this.props.isActive || isTransitionSource;

        if (hasNeverBeenMounted) {
            mountedPanelIds.push(panelId);
        }

        const ComponentToRender = this.props.navigationMenuItem.toRender;
        const shouldRenderComponent =
            isPanelVisible ||
            this.props.navigationMenuItem.unmountWhenInactive !== true;

        return (
            <span
                id={`calcTarget_renderPanel_${panelId}`}
                className={classNames({
                    [styles.showPanel]: isPanelVisible,
                    [styles.hidePanel]: !isPanelVisible,
                    [styles.panelActive]: this.props.isActive,
                    [styles.panelActiveTransitioning]:
                        this.props.isActive &&
                        this.props.transitionSourcePanelId !== undefined,
                    [styles.panelActivePending]:
                        this.props.isActive &&
                        this.props.transitionSourcePanelId !== undefined &&
                        !this.props.isPanelTransitionReady,
                    [styles.panelOutgoing]: isTransitionSource,
                    [styles.panelOutgoingFading]:
                        isTransitionSource && this.props.isPanelTransitionReady,
                })}
            >
                {shouldRenderComponent ? (
                    <ComponentToRender isPanelActive={isPanelVisible} />
                ) : null}
            </span>
        );
    }
}

const mountedPanelIds: EPanelId[] = [];

// function RouteElementId(nextProps: IRenderPanelProps) {
//     if (hasElementIdChanged) {
//         const isWorkflowsUrl =
//             nextProps.navigationMenuItem.id === EPanelId.Workflows;

//         if (isWorkflowsUrl) {
//             RouteWorkflows();
//         }
//     }
// }
